import { useCallback, useRef, useState } from "react";
import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";

export const ScrollableCard = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [atBottom, setAtBottom] = useState(false);

  const handleScroll = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    setAtBottom(el.scrollHeight - el.scrollTop - el.clientHeight < 40);
  }, []);

  return (
    <div className="relative flex-1 min-h-0">
      <Card
        ref={scrollRef}
        className={cn(
          "md:h-full overflow-y-auto rounded-[12px] border-nd-border shadow-none gap-0",
          className,
        )}
        onScroll={handleScroll}
      >
        {children}
      </Card>
      <div
        className="absolute inset-x-0 bottom-0 h-24 pointer-events-none rounded-b-[12px] transition-opacity duration-500"
        style={{
          background: "linear-gradient(to bottom, transparent, var(--card))",
          opacity: atBottom ? 0 : 1,
        }}
      />
    </div>
  );
};
